import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { SiFacebook, SiInstagram } from "react-icons/si";

const Footer = ({ onOpenMailingList }: { onOpenMailingList: () => void }) => {

  return (
    <footer className="bg-gothic-black border-t border-gothic-gray py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <img 
              src="/attached_assets/DC_LogoHeader_1761426135886.webp" 
              alt="Diane Corso Logo" 
              className="h-16 w-auto mb-4"
            />
            <p className="text-gray-300 leading-relaxed mb-6">San Francisco supernatural thriller writer crafting tales that blur the line between nightmare and reality. Step inside the darkness and discover what lurks in the shadows of the human psyche.</p>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/thecorsopapers/" 
                className="text-gothic-silver hover:text-blood-red transition-colors duration-300" 
                aria-label="Facebook"
                data-testid="social-facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SiFacebook size={20} />
              </a>
              <a 
                href="https://www.instagram.com/diane_corso_fiction" 
                className="text-gothic-silver hover:text-blood-red transition-colors duration-300" 
                aria-label="Instagram"
                data-testid="social-instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SiInstagram size={20} />
              </a>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-playfair font-bold text-gothic-white mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link href="/about"><span className="text-gray-400 hover:text-blood-red transition-colors duration-300" data-testid="footer-about">About</span></Link></li>
              <li><Link href="/books"><span className="text-gray-400 hover:text-blood-red transition-colors duration-300" data-testid="footer-books">Books</span></Link></li>
              <li><Link href="/blog"><span className="text-gray-400 hover:text-blood-red transition-colors duration-300" data-testid="footer-blog">Blog</span></Link></li>
              <li><Link href="/contact"><span className="text-gray-400 hover:text-blood-red transition-colors duration-300" data-testid="footer-contact">Contact</span></Link></li>
            </ul>
          </div>
          
          {/* Newsletter */}
          <div>
            <h4 className="text-lg font-playfair font-bold text-gothic-white mb-4">Stay Updated</h4>
            <p className="text-gray-400 text-sm mb-4">Subscribe for updates on new releases and events.</p>
            <Button 
              className="w-full bg-blood-red hover:bg-deep-red text-white text-sm font-semibold"
              data-testid="footer-newsletter-submit"
              onClick={onOpenMailingList}
            >
              Subscribe
            </Button>
          </div>
        </div>
        
        <hr className="border-gothic-gray my-8" />
        
        {/* Bottom Footer */}
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-sm mb-4 md:mb-0">
            <p>&copy; {new Date().getFullYear()} Diane Corso. All rights reserved.</p>
          </div>
          <div className="flex space-x-6 text-sm">
            <Link href="/privacy">
              <span className="text-gray-400 hover:text-blood-red transition-colors duration-300" data-testid="footer-privacy">
                Privacy Policy
              </span>
            </Link>
            <Link href="/terms">
              <span className="text-gray-400 hover:text-blood-red transition-colors duration-300" data-testid="footer-terms">
                Terms of Service
              </span>
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
